import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import '../styles/LanguageSelector.css';

const LanguageSelector: React.FC = () => {
  const { currentLanguage, setLanguage, availableLanguages } = useTranslation();

  const languageNames = {
    en: '🇺🇸 English',
    tr: '🇹🇷 Türkçe',
    de: '🇩🇪 Deutsch'
  };

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = event.target.value as 'en' | 'tr' | 'de';
    setLanguage(newLanguage);
  };

  return (
    <div className="language-selector">
      {/* Desktop version - full language names */}
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="language-select desktop-only"
      >
        {availableLanguages.map((lang) => (
          <option key={lang} value={lang}>
            {languageNames[lang]}
          </option>
        ))}
      </select>
      
      {/* Mobile version - compact dropdown */}
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="language-select mobile-only"
      >
        {availableLanguages.map((lang) => (
          <option key={lang} value={lang}>
            {lang === 'en' && '🇺🇸'}
            {lang === 'tr' && '🇹🇷'}
            {lang === 'de' && '🇩🇪'}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector; 